class VisualArtistProducts extends HTMLElement {
  async connectedCallback() {
    if (this.dataset.loaded === 'true') return;

    this.dataset.loaded = 'true';

    const collectionUrl = this.dataset.collectionUrl;
    const visualArtistId = this.dataset.visualArtistId;
    const maxProducts = Number(this.dataset.maxProducts);

    if (!collectionUrl || !visualArtistId || !Number.isInteger(maxProducts) || maxProducts < 1) {
      this.removeAttribute('aria-busy');
      return;
    }

    const url = new URL(collectionUrl, window.location.origin);
    url.searchParams.set('view', 'visual-artist-products');
    url.searchParams.set('filter.p.m.custom.visual_artist', visualArtistId);

    try {
      const response = await fetch(url, { credentials: 'same-origin' });
      if (!response.ok) throw new Error(`Request failed with status ${response.status}.`);

      const responseDocument = new DOMParser().parseFromString(await response.text(), 'text/html');
      const productsResponse = responseDocument.querySelector('[data-visual-artist-products-response]');

      if (!(productsResponse instanceof HTMLElement)) {
        throw new Error('The visual artist products response is missing.');
      }

      if (productsResponse.dataset.visualArtistFilterActive !== 'true') {
        throw new Error('The custom.visual_artist storefront filter is not active.');
      }

      const productItems = Array.from(
        productsResponse.querySelectorAll('[data-visual-artist-product]')
      ).filter((productItem) => {
        if (!(productItem instanceof HTMLElement)) return false;

        return (productItem.dataset.visualArtistIds ?? '')
          .split(',')
          .some((artistId) => artistId.trim() === visualArtistId);
      });

      const productsList = this.querySelector('[data-visual-artist-products-list]');
      const productsContent = this.querySelector('[data-visual-artist-products-content]');

      if (!(productsList instanceof HTMLUListElement) || !(productsContent instanceof HTMLElement)) return;
      if (productItems.length === 0) return;

      productsList.replaceChildren(...productItems.slice(0, maxProducts));
      productsContent.hidden = false;
    } catch (error) {
      console.error('Unable to load visual artist products.', error);
    } finally {
      this.removeAttribute('aria-busy');
    }
  }
}

if (!customElements.get('visual-artist-products')) {
  customElements.define('visual-artist-products', VisualArtistProducts);
}
